import { render, staticRenderFns } from "./EnrichmentTable.vue?vue&type=template&id=7da9633d&scoped=true"
import script from "./EnrichmentTable.vue?vue&type=script&lang=js"
export * from "./EnrichmentTable.vue?vue&type=script&lang=js"
import style0 from "./EnrichmentTable.vue?vue&type=style&index=0&id=7da9633d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da9633d",
  null
  
)

export default component.exports